import gql from 'graphql-tag'

export const vantaggiPage = gql`
 query vantaggiPage($locale: SiteLocale) {
    vantaggi(locale: $locale) {
      intro
      title
      subtitle
      seo {
        title
        image {
          url
        }
        description
      }
      accordion {
        title
        content
      }
      imageDesk {
        responsiveImage {
          src
          srcSet
        }
      }
      imageMobile {
        responsiveImage {
          src
          srcSet
        }
      }
    }
  }
`

export const vantaggiHome = gql`
 query vantaggi($locale: SiteLocale) {
    vantaggi(locale: $locale) {
      introHomepage
      titleHomepage
      listBenefit {
        elementoLista
      }
      labelCta
    }
  }
`
